export default "__VITE_ASSET__8930867c__"